var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");
$CLJS.oH=require("moment");module.exports=$CLJS.oH;